import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { JumpPoints } from '../components/JumpPoints';
import { QueueCard } from '../components/QueueCard';
import { ActivityFeed } from '../components/ActivityFeed';
import { FunnelCard } from '../components/FunnelCard';
import { LeadModal } from '../components/LeadModal';
import { currentUser, type Lead } from '../data/mockData';
export function Overview() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<Lead | null>(null);
  return <div className="space-y-4" data-id="element-360" data-mp="2liq8h0ij8gro">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-361" data-mp="2lihwdau8hfhj">
        <div data-id="element-362" data-mp="2qhujzxsxiql6">
          <h1 className="text-[22px] font-bold text-ink" data-id="element-363" data-mp="2qickj6mmjqyw">
            Good morning, {currentUser.firstName}
          </h1>
          <p className="mt-1 text-[13px] text-gray-500" data-id="element-364" data-mp="r5ryki0qvm4v">
            Friday, July 17 · <span className="font-semibold text-ink" data-id="element-365" data-mp="w3a19qo6554f">5 new leads</span>{' '}
            assigned to you so far today
          </p>
        </div>
        <button type="button" onClick={() => navigate('/leads')} className="inline-flex items-center gap-2 rounded-lg bg-brand px-4 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-brand/40" data-id="element-366" data-mp="2ze2p65jl6ali">
          Work new leads
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-367" data-mp="3ibndnbifv75l" />
        </button>
      </div>

      <JumpPoints data-id="element-368" data-mp="3ea2707whzp3u" />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_340px]" data-id="element-369" data-mp="3e9iooq2xqypa">
        <div className="space-y-4" data-id="element-370" data-mp="39ayzmgt1p6sp">
          <QueueCard onSelect={setSelected} data-id="element-371" data-mp="399wc8iuxlmhj" />
          <FunnelCard data-id="element-372" data-mp="39cs9e4yyg74x" />
        </div>
        <ActivityFeed data-id="element-373" data-mp="34ce2iq93b38h" />
      </div>

      <LeadModal lead={selected} onClose={() => setSelected(null)} data-id="element-374" data-mp="34bcku2xkjihs" />
    </div>;
}